import React from "react";

import PropTypes from "prop-types";

const DetailsCard = ({
  color = "active",
  direction = "positive",
  title,
  mainValue,
  statisticValue,
  statisticDescription,
  icon,
}) => {
  return (
    <div className="details-card">
      <div className="details-card__wrapper">
        <div
          className={`details-card__icon-wrapper details-card__icon-wrapper--${color}`}
        >
          <img src={icon} alt="icon" />
        </div>
        <div className="details-card__information">
          <div className="details-card__title">{title}</div>

          <div className="details-card__value details-card__value--bold">
            {mainValue}
          </div>
        </div>

        <div className="details-card__line-break" />

        <div className="details-card__statistics-values">
          <span
            className={`details-card__value details-card__value--lighter details-card__value--smaller details-card__value--${direction}`}
          >
            {statisticValue}&nbsp;
          </span>
          <span className="details-card__value--lighter details-card__value--smaller">
            {statisticDescription}
          </span>
        </div>
      </div>
    </div>
  );
};

DetailsCard.propTypes = {
  color: PropTypes.oneOf(["active", "danger", "success"]),
  direction: PropTypes.oneOf(["positive", "negative"]),
  title: PropTypes.string.isRequired,
  mainValue: PropTypes.string.isRequired,
  statisticValue: PropTypes.string.isRequired,
  statisticDescription: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
};

export default DetailsCard;
